import {
  VerifiedAuthenticatedUser,
  VerifiedAuthenticatedUserWithAccessToken,
} from "~types/types";

export function resolveUserEmail(
  user: VerifiedAuthenticatedUser | VerifiedAuthenticatedUserWithAccessToken,
): string | null {
  return user.emails?.items?.[0]?.email ?? null;
}
